import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import {
    IconComponent,
    IDynamicElement,
    ImageData,
    ImageDimensions,
    ImageItemComponent,
    LinkDirective,
} from '@sirius/common';
import { IFeaturedLinkItem, IFeaturedLinksSideNav } from 'shared/models';

let nextInstanceId = 0;

const ROW_PHOTO = new ImageData('featured-link-row', [
    new ImageDimensions(736, 552),
    new ImageDimensions(230, 173),
    new ImageDimensions(230, 173),
    new ImageDimensions(230, 173),
    new ImageDimensions(230, 173),
]);

@Component({
    selector: 'ur-featured-links-side-nav',
    templateUrl: './featured-links-side-nav.component.html',
    styleUrl: './featured-links-side-nav.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [IconComponent, ImageItemComponent, LinkDirective],
})
export class FeaturedLinksSideNavComponent implements IDynamicElement<IFeaturedLinksSideNav> {
    readonly config = input<IFeaturedLinksSideNav>();

    protected readonly headingId = `ur-featured-links-title-${nextInstanceId}`;
    protected readonly navHeadingId = `ur-featured-links-nav-${nextInstanceId++}`;
    protected readonly rowPhoto = ROW_PHOTO;

    protected readonly title = computed(() => this.config()?.title?.trim() || null);
    protected readonly introHtml = computed(() => this.config()?.textHtml || null);
    protected readonly noticeHtml = computed(() => this.config()?.noticeHtml || null);
    protected readonly items = computed<IFeaturedLinkItem[]>(() => this.config()?.items ?? []);
    protected readonly sideNavTitle = computed(() => this.config()?.sideNavTitle?.trim() || null);
    protected readonly sideNavLinks = computed(() => this.config()?.sideNavLinks ?? []);
    protected readonly hasSideNav = computed(() => this.sideNavLinks().length > 0);
    protected readonly hasContent = computed(
        () => this.items().length > 0 || this.hasSideNav() || this.noticeHtml() !== null
    );
}
